// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2chGE","dragIcon":"SortableItem_dragIcon__3JlFc","disabled":"SortableItem_disabled__3tkOl"};